import { Component } from "react";
import { Routes, Route, RouteProps } from "react-router-dom";

type RouterMapProps = {
  renderRoute?: RouteProps[];
};

export class RouterMap extends Component<RouterMapProps> {
  static defaultProps: Partial<RouterMapProps> = {
    renderRoute: [],
  };

  render() {
    const { renderRoute } = this.props;

    return (
      <Routes>
        {renderRoute?.map((item, index) => (
          <Route key={`route_list_${index}`} {...item} />
        ))}
      </Routes>
    );
  }
}
